import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const exportNotesApi = createApi({
  reducerPath: "exportNotesApi",
  baseQuery,
  tagTypes: ["exportNotes"],
  endpoints: (builder) => ({


    createExportNotes: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/exportNote/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportNote: data },
      }),
      invalidatesTags: ["exportNotes"],
    }),


    // Updated Export Table

    updateExportNotes: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/export/exportNote/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportNote: data },
      }),
      invalidatesTags: ["exportNotes"],
    }),



    getNotesByExporterId: builder.query({
      query: ({ id }) => `export/exportNote/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item) => ({
          ...item,
          id: item.exportNoteId,
        }));
      },
      providesTags: ["exportNotes"],
    }),

    // 🔹 Get single invoice by Id
    getNotesById: builder.query({
      query: ({ id, subId }) =>
        `export/exportNote/${id}/${subId}`,
      transformResponse: (response) => response?.data ?? null,


      providesTags: ["exportNotes"],
    }),

    deleteExportNote: builder.mutation({
      query: ({ id }) => ({
        url: `export/exportNote/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["exportNotes"],
    }),


    fileUpload: builder.mutation({
      query: ({ file, token }) => {


        const formData = new FormData();
        formData.append("File", file);
        for (let [key, value] of formData.entries()) {
        }
      
        return {
          url: 'file-upload/upload',
          method: "POST",
          body: formData,
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
            "Authorization": `Bearer ${token}`,
          },
        };
      },
      invalidatesTags: ["fileUpload"],
    }),
  })
});
export const {
  useCreateExportNotesMutation, 
  useUpdateExportNotesMutation,
  useLazyGetNotesByExporterIdQuery,
  useDeleteExportNoteMutation,
  useFileUploadMutation,

} = exportNotesApi;


